class Balance {
    constructor({ asset_code, balance }) {
      this.asset_code = asset_code;
      this.balance = balance;
    }
  }
  
  export default Balance;